const socializationIconMap = {
    // 全部 
   '8': {
        code: '8',
        name: '全部',
        item_icon_: require('@/assets/images/socializationIcon/btn_menu_all.png'),
        item_icon: require('@/assets/images/socializationIcon/btn_menu_all_c.png'),
        className: 'type-icon-class',
    },
    // 经销商
   '0': {
        code: '0',
        name: '经销商',
        item_icon_: require('@/assets/images/socializationIcon/btn_menu_jxs.png'),
        item_icon: require('@/assets/images/socializationIcon/btn_menu_jxs_c.png'),
        className: 'type-icon-class',
    },
    // 维修站
    '1': {
        code: '1',
        name: '维修站',
        item_icon_: require('@/assets/images/socializationIcon/btn_menu_wxz.png'),
        item_icon: require('@/assets/images/socializationIcon/btn_menu_wxz_c.png'),
        className: 'type-icon-class',
    },
    // 转运站
    '2': {
        code: '2',
        name: '转运站',
        item_icon_: require('@/assets/images/socializationIcon/btn_menu_zyz.png'),
        item_icon: require('@/assets/images/socializationIcon/btn_menu_zyz_c.png'),
        className: 'type-icon-class',
    },
    // 农资站
    '3': {
        code: '3',
        name: '农资站',
        item_icon_: require('@/assets/images/socializationIcon/btn_menu_nzz.png'),
        item_icon: require('@/assets/images/socializationIcon/btn_menu_nzz_c.png'),
        className: 'type-icon-class',
    },
    // 加油站
    '4': {
        code: '4',
        name: '加油站',
        item_icon_: require('@/assets/images/socializationIcon/btn_menu_jyz.png'),
        item_icon: require('@/assets/images/socializationIcon/btn_menu_jyz_c.png'),
        className: 'type-icon-class',
    },
    // 机手
   '5': {
        code: '5',
        name: '机手',
        item_icon_: require('@/assets/images/socializationIcon/btn_menu_js.png'),
        item_icon: require('@/assets/images/socializationIcon/btn_menu_js_c.png'),
        className: 'type-icon-class',
    },
    // 帮手
    '6': {
        code: '6',
        name: '帮手',
        item_icon_: require('@/assets/images/socializationIcon/btn_menu_bs.png'),
        item_icon: require('@/assets/images/socializationIcon/btn_menu_bs_c.png'),
        className: 'type-icon-class',
    },
    // 农活
   '7': {
        code: '7',
        name: '农活',
        item_icon_: require('@/assets/images/socializationIcon/btn_menu_nh.png'),
        item_icon: require('@/assets/images/socializationIcon/btn_menu_nh_c.png'),
        className: 'type-icon-class',
    },
        // 农活
   '9': {
        code: '9',
        name: '粮食经纪人',
        item_icon_: require('@/assets/images/socializationIcon/btn_menu_lsjjr.png'),
        item_icon: require('@/assets/images/socializationIcon/btn_menu_lsjjr_c.png'),
        className: 'type-icon-last-class',
    },
        
}
export default socializationIconMap